var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-item color-card-item color-card-item-small",
      attrs: {
        "data-card-id": _vm.isExist(_vm.color_tone)
          ? _vm.color_tone.card.id
          : ""
      }
    },
    [
      _c("div", { staticClass: "inner" }, [
        _c(
          "a",
          { attrs: { href: _vm.color_tone.details_url, target: "_blank" } },
          [
            _c("div", {
              staticClass: "color-card-color-background",
              style: { background: _vm.color_tone.cssColor }
            })
          ]
        ),
        _c(
          "div",
          { staticClass: "color-card-detail" },
          [
            _c("div", { staticClass: "inline-extra-icon" }, [
              _c("div", { staticClass: "extra" }, [
                _c(
                  "i",
                  {
                    staticClass: "actionToggleDashboard material-icons ",
                    attrs: {
                      "data-card-id": _vm.color_tone.card.id,
                      "data-add-url": "/myBaumit/ajaxAddCardToDashboard",
                      "data-delete-url":
                        "/myBaumit/ajaxDeleteCardFromDashboard",
                      "data-added-to-dashboard": "0"
                    }
                  },
                  [_vm._v(" star_border")]
                )
              ])
            ]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("products_color_code")) +
                "\n            "
            ),
            _c("div", { staticClass: "color-card-title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.color_tone.name) +
                  "\n            "
              )
            ]),
            _vm.color_tone.hex.length > 0
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("calc_colorpicker_hex")) +
                      ": #" +
                      _vm._s(_vm.color_tone.hex)
                  ),
                  _c("br")
                ]
              : _vm._e(),
            _vm.color_tone.rgbSlash != null &&
            _vm.color_tone.rgbSlash.length > 0
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("calc_colorpicker_rgb")) +
                      ": " +
                      _vm._s(_vm.color_tone.rgbSlash)
                  ),
                  _c("br")
                ]
              : _vm._e(),
            _vm.color_tone.tsr != null && _vm.color_tone.tsr.toString != "0"
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("general_color_tsr")) +
                      ": " +
                      _vm._s(_vm.color_tone.tsrHidden)
                  ),
                  _c("br")
                ]
              : _vm._e(),
            _vm.color_tone.hbw.toString().length > 0
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("general_color_hbw")) +
                      ": " +
                      _vm._s(_vm.color_tone.hbw)
                  ),
                  _c("br")
                ]
              : _vm._e(),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.color_tone.details_url,
                  target: "_blank",
                  title: _vm.color_tone.name
                }
              },
              [_vm._v(_vm._s(_vm.trans("general_more_info")))]
            )
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }